import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  SvgIcon,
} from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';
import Logo from '../../../components/shared/Logo';
import { THEMES } from '../../../theme';
import Account from './Account';

const TopBar = ({ className, onMobileNavOpen = () => {}, ...rest }) => {
  return (
    <AppBar
      className={className}
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 100,
        ...(theme.name === THEMES.LIGHT
          ? {
              boxShadow: 'none',
              backgroundColor: theme.palette.primary.main,
            }
          : {}),
        ...(theme.name === THEMES.ONE_DARK
          ? {
              backgroundColor: theme.palette.background.default,
            }
          : {}),
      })}
      {...rest}
    >
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
